import { useEffect } from 'react'
import './index.less'
import { trackGdp } from '../../../../utils/gio-report'
import { getReportVipData, privilegesEnum } from '../../utils'
import IconRightPng from '../../assets/icon_right.png'
import { processOssImage } from '@xp-design/mobile/lib/utils/oss-process-image'

const TitleBarCard = ({ title, tag, children, className = '', onClickTitle = () => {}, withoutTitle = false, withoutBottomLine = false, rightText = '', userLevelInfo = null, type = '' }: any) => {

  useEffect(() => {
    if(userLevelInfo && type){
      trackGdp('P11222', 'B027', {
        ...getReportVipData(userLevelInfo),
        'vip_privileges_details': privilegesEnum[type]
      })
    }
  }, [userLevelInfo])

  const titleCilck = () => {
    trackGdp('P11222', 'B028', {
      ...getReportVipData(userLevelInfo),
      'vip_privileges_details': privilegesEnum[type]
    })
    onClickTitle()
  }

  return (
    <div className='charge-vip-title-bar-card'>
      <div
        className={className}
        onScroll={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        {!withoutTitle && <div className='title-bar' onClick={titleCilck}>
          <div className='title'>
            <div className='text'>{title}</div>
            {tag && <span className='tag'>{tag}</span>}
          </div>
          <div className='right'>
            <span>{rightText}</span>
            <img className='icon' alt='' src={processOssImage(IconRightPng)} />
          </div>
        </div>}
        {children}
      </div>
      {!withoutBottomLine && <div className='bottom-gap'></div>}
    </div>
  )
}

export default TitleBarCard
